<script setup>
import { ref, onMounted, computed } from 'vue';
import { getAllUsers } from '@/api/adminApi.js';
import { useAuthStore } from '@/stores/auth.js';

/** @type {import('vue').Ref<Map<number, User>} */
const users = ref(new Map());
const auth = useAuthStore();

// 表示用のuserList。配列に変換済み
const userList = computed(() => {
  return [...users.value.values()];
});
// ページロード時（コンポーネントマウント時）に呼び出す
onMounted(async () => {
  loadUsers();
});
/**
 * Todo初回呼び出し
 */
async function loadUsers() {
  if (!auth.isAdmin) {
    console.log('管理者以外はユーザーリストを見ることができません。');
    return;
  }
  users.value = await getAllUsers();
}
</script>
<template>
  <ul>
    <li v-for="user in userList" :key="user.id">
      <router-link
        :to="{ name: 'UserEdit', params: { id: user.id } }"
        active-class="bg-orange-100 font-bold"
        class="block p-3 mb-1 rounded-lg transition-colors hover:bg-orange-50 active:bg-orange-100"
      >
        {{ user.userName }}
      </router-link>
    </li>
  </ul>
</template>
